export default function LoadingScreen() {
  return null;
}
